import { Row } from "style/preset"
import styled, { css } from "styled-components"

import { ReactComponent as WarnSvg } from 'assets/svgs/waring_icon.svg' 
import StyledContainer from "style/styledContainer"
import { useCallback } from "react"
import { useAppSelector } from "hooks/redux/hooks"


interface Props {
    btnFlag?: boolean
}

const SlippageWarnCom = ({btnFlag = false}: Props) => {
    const { slippage } = useAppSelector((state) => state.coreInfo)

    const checkSlippage = useCallback(() => {
        let level = 0;
        if(slippage < 5) return level
        if(slippage >= 5 &&  slippage < 10) {
            level = 1;
        } else if(slippage >= 10 &&  slippage < 20) {
            level = 2;
        } else {
            level = 3;
        }
        return level
    }, [slippage])

    return <>
        {
            slippage < 20 ? (
                btnFlag ? <></> : <StyledContainer>{slippage}%</StyledContainer>
            )
             : <SlippageWarnWrap $level={checkSlippage()}>
                <WarnSvgWrap></WarnSvgWrap>
                <WarnTextWrap>{btnFlag ? 'Slippage ~ ':''}{slippage}%</WarnTextWrap>
            </SlippageWarnWrap>
        }
    </>
}

const WarnSvgWrap = styled(WarnSvg)`
    width: 14px;
    height: 14px;
`

const WarnTextWrap = styled(StyledContainer)`
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    margin-left: 8px;
`

const SlippageWarnWrap = styled(Row)<{$level: number}>`
    padding: 8px 6px;
    border-radius: 6px;

    ${
        ({$level, theme}) => $level === 1 ? css`
            background-color: #F6FB79;
            ${WarnSvgWrap} {
                path, rect {
                    fill: ${theme.basicBlack}
                }
            };
            ${WarnTextWrap} {
                color: ${theme.basicBlack}
            }
        ` : $level === 2 ? css`
            background-color: #FFDD64;
            ${WarnSvgWrap} {
                path, rect {
                    fill: ${theme.basicBlack}
                }
            };
            ${WarnTextWrap} {
                color: ${theme.basicBlack}
            }
        ` : css`
            background-color: #E000E0;
            ${WarnSvgWrap} {
                path, rect {
                    fill: ${theme.basicWhite}
                }
            };
            ${WarnTextWrap} {
                color: ${theme.basicWhite}
            }
        ` 
    }
`

export default SlippageWarnCom